import { c as _c } from "react/compiler-runtime";
import type { IdDocImageTypes } from '@onefootprint/types';
import { useTranslation } from 'react-i18next';
import { useTimeout } from 'usehooks-ts';
import { ImageIcons, TRANSITION_DELAY_DEFAULT } from '../../../constants';
type NextSideProps = {
  nextSideImageType: IdDocImageTypes;
  onComplete: () => void;
};
const NextSide = t0 => {
  const $0 = _c(15);
  const {
    nextSideImageType,
    onComplete
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.components.next-side"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const Icon = ImageIcons[nextSideImageType];
  let t2;
  if ($0[1] !== onComplete) {
    t2 = () => {
      onComplete();
    };
    $0[1] = onComplete;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  useTimeout(t2, TRANSITION_DELAY_DEFAULT);
  let t3;
  if ($0[3] !== Icon) {
    t3 = <Icon color="primary" />;
    $0[3] = Icon;
    $0[4] = t3;
  } else {
    t3 = $0[4];
  }
  let t4;
  if ($0[5] !== nextSideImageType) {
    t4 = $ => $[nextSideImageType];
    $0[5] = nextSideImageType;
    $0[6] = t4;
  } else {
    t4 = $0[6];
  }
  let t5;
  if ($0[7] !== t || $0[8] !== t4) {
    t5 = t(t4);
    $0[7] = t;
    $0[8] = t4;
    $0[9] = t5;
  } else {
    t5 = $0[9];
  }
  let t6;
  if ($0[10] !== t5) {
    t6 = <p className="text-label-1 text-primary mt-4 text-center fp-text">{t5}</p>;
    $0[10] = t5;
    $0[11] = t6;
  } else {
    t6 = $0[11];
  }
  let t7;
  if ($0[12] !== t3 || $0[13] !== t6) {
    t7 = <div className="flex flex-col items-center">{t3}{t6}</div>;
    $0[12] = t3;
    $0[13] = t6;
    $0[14] = t7;
  } else {
    t7 = $0[14];
  }
  return t7;
};
export default NextSide;